import { useEffect, useRef, useState } from "react";
import { ProductionCostsViewModel } from "../../../viewmodels/setup/productionCosts/ProductionCostsViewModel";
import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";
import { withRouter } from "../../../shared/utility";
import SlideOver from "../../../components/slideOver/SlideOver";
import {
  SetupActions,
  SetupPage,
  SetupTable,
  SetupTd,
} from "../../../components/setup/SetupPage";

function ProductionCosts(props) {
  const { addSnackbar, logout } = props;
  const {
    getProductionCosts,
    loading,
    productionCosts,
    openAddProductionCostSlideOver,
    setSlideOver,
    slideOver,
    viewProductionCostDetails,
  } = ProductionCostsViewModel(logout, addSnackbar);

  var currentPage = 1;
  useEffect(() => {
    getProductionCosts(null, currentPage);
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);
  const searchRef = useRef();

  const handleSearch = () => {
    getProductionCosts(searchRef.current.value, currentPage);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getProductionCosts(searchRef.current.value, currentPage);
  };

  return (
    <div>
      <SetupPage
        title="Production Costs"
        description="Manage cost buckets used when calculating production and finished goods costs."
        searchPlaceholder="Search production costs"
        searchRef={searchRef}
        onSearch={handleSearch}
        actions={[
          {
            label: "Add Production Cost",
            onClick: openAddProductionCostSlideOver,
          },
        ]}
        loading={loading}
        tableColumns={["Name"]}
        totalRecords={productionCosts.total}
        first={first}
        rows={rows}
        onPageChange={handlePagination}
      >
        <SetupTable columns={["Name"]} emptyText="No production costs found.">
          {productionCosts.data?.map((item, index) => (
            <tr key={item.id} className="transition hover:bg-[#F6F8FB]/80">
              <SetupTd muted={false}>{item.name}</SetupTd>
              <SetupActions>
                <button
                  type="button"
                  onClick={() => viewProductionCostDetails(item, index)}
                  className="inline-flex min-w-[68px] justify-center rounded-lg border border-[#E2E8F0] bg-white px-3 py-1.5 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB]"
                >
                  Edit
                </button>
              </SetupActions>
            </tr>
          ))}
        </SetupTable>
      </SetupPage>
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductionCosts),
);
